import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import VendorRegistrationAU from '../admin_module/vendor/vendorRegistration/vendorRegistration_au';
import VendorWorkOrderAU from '../admin_module/vendor/vendorWorkOrder/vendorWorkOrder_au';
import Loader from '../../utils/Loader';
import { ToastContainer } from 'react-toastify';
import ExhibitorHeader from '../../common_components/exhibitor_module_header';
import HeaderWithLogo from '../../common_components/header_with_logo';
import VendorDrawer from '../../common_components/vendor_module_drawer';
import AdminDrawer from "../../common_components/admin_module_drawer";
import { withRouter } from '../../utils/withRouter';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { QrReader } from "react-qr-reader";
import { ByPassReasonActionId, toastError, toastSuccess } from '../../utils/constants';
import Modal from "react-modal";
import { entryGateVerifyQR_action, entryGateQRList_action, entryGateUpdateAccessPassLog_action } from '../../actions/entryGate_module_action/entryGate_action';
import Pagination from "../../utils/pagination";
import moment from 'moment';
import { fill_action } from '../../actions/fillCombo_action';
import ConfirmationModal from "../../common_components/confirmationa_modal";

class EntryGate extends Component {
    constructor(props) {
        super(props)
        this.state = {
            CompanyName: '',
            entryDate: new Date(),
            confirmationObj: { message: '', buttonName: '', action: '' },
            popArg: [],
            isOpenConfirmationModal: false,
            isOpen: false,
            isQrCode: true,
            Remark: '',
            RemarkErr: '',
            IsByPass: '',
            IsByPassErr: '',
            showPopup: false,
            IsByPass: '',
            AdditionalRemark: '',
            EntryGateMsg: '',
            Instrunction: '',
            InstrunctionErr: '',
            EntryGateList: [],
            CountPopList: [],
            currentPage: 1,
            ExhEntryPassHdrID: '',
            ExhExitPassHdrID: '',
            IsEntryPassLog: false,
            IsVerify: false,
            isChangeFeilds: false,
            AccessPassLogID: null,
            isGateEntry: sessionStorage.getItem('RoleIDSS') == 18,
            isRecording: false,
            Instrunction: "",
            micStatus: "Microphone inactive",
            isRecording2: false,
            micStatus2: "Microphone inactive",
            summaryPage: 'Entry',
            IsEntryExit: 1,
            ReasonID: '',
            ReasonList: [],
            ReasonErr: '',
            isOpenScanByNoModal: false,
            ScanByNo: '',
            ScanByNoErr: ''
        };


        this.speechInputRef = createRef();
        this.recognition = null;
        this.audioStream = null;
        this.manuallyStopped = false;

        this.speechInputRef2 = createRef();
        this.recognition2 = null;
        this.audioStream2 = null;
        this.manuallyStopped2 = false;

        this.handleConfirmation = this.handleConfirmation.bind(this)
    }


    handleConfirmation(flag) {
        const { confirmationObj, popArg } = this.state;
        if (flag) {
            if (confirmationObj.action == 0) {
                this.submitEntryGateQR()
            }
        }
        this.setState({ isOpenConfirmationModal: false })
    }

    componentDidMount() {
        this.getFillList(ByPassReasonActionId, "", "", "", "", "");
        this.entryGateQRList();
        this.setState({
            summaryPage: sessionStorage.getItem("summaryPage")
                ? sessionStorage.getItem("summaryPage")
                : 'Entry'
        });
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from, flag) {
        const { } = this.state;
        this.setState({ isLoading: !flag ? false : true });
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    if (actionID === ByPassReasonActionId) {
                        this.setState({ ReasonList: data.data });
                    }
                }
                this.setState({ isLoading: false });
            })
            .catch((e) => {
                console.log(e);
            });
    }

    componentWillUnmount() {
        this.cleanUp();
        this.cleanUp2();
    }

    /* ===================== HANDLE 1 ===================== */

    createRecognition = () => {
        const SpeechRecognition =
            window.SpeechRecognition || window.webkitSpeechRecognition;

        const recognition = new SpeechRecognition();
        recognition.continuous = false;
        recognition.interimResults = true;
        recognition.lang = "en-US";

        recognition.onresult = this.handleResult;
        recognition.onend = this.handleEnd;
        recognition.onerror = this.handleError;

        return recognition;
    };

    handleResult = (event) => {
        let finalTranscript = "";

        for (let i = 0; i < event.results.length; i++) {
            if (event.results[i].isFinal) {
                finalTranscript += event.results[i][0].transcript;
            }
        }

        if (finalTranscript) {
            this.setState(prev => ({
                Instrunction: prev.Instrunction
                    ? `${prev.Instrunction} ${finalTranscript}`
                    : finalTranscript,
                isChangeFeilds: true
            }));
        }
    };

    // ✅ SAFE auto-restart
    handleEnd = () => {
        if (!this.manuallyStopped && this.state.isRecording && this.recognition) {
            try {
                this.recognition.start();
            } catch { }
        }
    };

    handleError = () => {
        this.stopRecording();
    };

    startRecording = async () => {
        if (this.state.isRecording) return;

        this.manuallyStopped = false;

        if ("SpeechRecognition" in window || "webkitSpeechRecognition" in window) {
            this.recognition = this.createRecognition();
            try {
                this.recognition.start();
            } catch { }
        }

        this.setState({
            isRecording: true,
            micStatus: "Microphone active - listening..."
        });
    };

    stopRecording = () => {
        this.manuallyStopped = true;

        if (this.recognition) {
            this.recognition.onend = null;
            this.recognition.stop();
            this.recognition = null;
        }

        if (this.audioStream) {
            this.audioStream.getTracks().forEach(t => t.stop());
            this.audioStream = null;
        }

        this.setState({
            isRecording: false,
            micStatus: "Microphone inactive"
        });
    };

    toggleRecording = () => {
        this.state.isRecording ? this.stopRecording() : this.startRecording();
    };

    cleanUp = () => {
        this.manuallyStopped = true;
        this.recognition?.stop();
        this.audioStream?.getTracks().forEach(t => t.stop());
    };

    /* ===================== HANDLE 2 ===================== */

    createRecognition2 = () => {
        const SpeechRecognition =
            window.SpeechRecognition || window.webkitSpeechRecognition;

        const recognition = new SpeechRecognition();
        recognition.continuous = false;
        recognition.interimResults = true;
        recognition.lang = "en-US";

        recognition.onresult = this.handleResult2;
        recognition.onend = this.handleEnd2;
        recognition.onerror = this.handleError2;

        return recognition;
    };

    handleResult2 = (event) => {
        let finalTranscript = "";

        for (let i = 0; i < event.results.length; i++) {
            if (event.results[i].isFinal) {
                finalTranscript += event.results[i][0].transcript;
            }
        }

        if (finalTranscript) {
            this.setState(prev => ({
                Remark: prev.Remark
                    ? `${prev.Remark} ${finalTranscript}`
                    : finalTranscript,
                isChangeFeilds: true
            }));
        }
    };

    // ✅ SAFE auto-restart
    handleEnd2 = () => {
        if (!this.manuallyStopped2 && this.state.isRecording2 && this.recognition2) {
            try {
                this.recognition2.start();
            } catch { }
        }
    };

    handleError2 = () => {
        this.stopRecording2();
    };

    startRecording2 = async () => {
        if (this.state.isRecording2) return;

        this.manuallyStopped2 = false;

        if ("SpeechRecognition" in window || "webkitSpeechRecognition" in window) {
            this.recognition2 = this.createRecognition2();
            try {
                this.recognition2.start();
            } catch { }
        }

        this.setState({
            isRecording2: true,
            micStatus2: "Microphone active - listening..."
        });
    };

    stopRecording2 = () => {
        this.manuallyStopped2 = true;

        if (this.recognition2) {
            this.recognition2.onend = null;
            this.recognition2.stop();
            this.recognition2 = null;
        }

        if (this.audioStream2) {
            this.audioStream2.getTracks().forEach(t => t.stop());
            this.audioStream2 = null;
        }

        this.setState({
            isRecording2: false,
            micStatus2: "Microphone inactive"
        });
    };

    toggleRecording2 = () => {
        this.state.isRecording2 ? this.stopRecording2() : this.startRecording2();
    };

    cleanUp2 = () => {
        this.manuallyStopped2 = true;
        this.recognition2?.stop();
        this.audioStream2?.getTracks().forEach(t => t.stop());
    };

    entryGateQRList() {
        const { CompanyName, entryDate, IsEntryExit } = this.state;
        this.setState({ isLoading: true });
        this.props
            .entryGateQRList_action(CompanyName, moment(entryDate).format('YYYY-MM-DD'), IsEntryExit)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        EntryGateList: data.data[0],
                        CountPopList: data.data[1],
                        isLoading: false
                    });
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    entryGateVerifyQR = async (value) => {
        const { IsByPass, Remark, AdditionalRemark, isGateEntry, IsEntryExit } = this.state;

        try {
            this.setState({ isLoading: true, isQrCode: false });

            const data = await this.props.entryGateVerifyQR_action(
                isGateEntry ? 1 : 2,
                value,
                IsByPass,
                Remark,
                AdditionalRemark,
                IsEntryExit
            );

            if (data?.error !== 1) {
                this.setState({
                    QrCodeValue: value ? value.split("/") : "",
                    isQrCode: false,
                    EntryGateMsg: data?.data?.[0]?.[0]?.Message || '',
                    IsVerify: data?.data?.[0]?.[0]?.IsVerify || false,
                    AccessPassLogID: data?.data?.[1]?.[0]?.AccessPassLogID || null,
                    InstrunctionErr: '',
                    Remark: '',
                    isLoading: false
                });
            } else {
                throw new Error("Invalid QR Code");
            }

        } catch (err) {

            this.setState({
                QrCodeValue: "",
                isQrCode: true,
                EntryGateMsg: '',
                IsVerify: false,
                AccessPassLogID: null,
                InstrunctionErr: '',
                Remark: '',
                isLoading: false,
                isOpen: false,
                showPopup: false,
                isOpen: false,
            });

            if (err.message === "Invalid QR Code") {
                toastError("Invalid QR Code");
            }
        } finally {
            this.entryGateQRList();
            this.resetFuntion();
        }
    };

    submitEntryGateQR() {
        const { AccessPassLogID, IsByPass, Remark, Instrunction, IsVerify, isGateEntry, ReasonID } = this.state;
        if (!IsVerify ? IsByPass && ReasonID != '' : true) {
            if (ReasonID == 2) {
                if (Remark == '' || Remark == null) {
                    this.setState({
                        RemarkErr: "Please enter remark",
                    });
                    toastError("Please enter mandatory feilds!");
                    return
                }
            }
            this.setState({ isLoading: true });
            this.props
                .entryGateUpdateAccessPassLog_action(AccessPassLogID, IsByPass, Instrunction, Remark, ReasonID)
                .then((data) => {
                    if (data.error != 1) {
                        toastSuccess(`${isGateEntry ? "Venue" : "Hall"} entry successfuly submitted`);
                        this.setState({
                            isLoading: false,
                            isOpen: false,
                            isQrCode: true,
                            Remark: "",
                            isChangeFeilds: false,
                            IsByPass: false,
                            InstrunctionErr: '',
                            Remark: ''
                        });
                        this.entryGateQRList();
                        this.resetFuntion();
                    } else {
                        this.setState({ isLoading: false });
                        toastError(data.msg);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            if (!IsByPass) {
                this.setState({
                    IsByPassErr: "Please checked by pass",
                });
            }
            if (ReasonID == '') {
                this.setState({
                    ReasonErr: "Please select reason",
                });
            }

            toastError("Please enter mandatory feilds!");
        }
    }

    submitScanByNo = () => {
        const { ScanByNo, isGateEntry, summaryPage } = this.state;
        if (!ScanByNo || ScanByNo.trim() === '') {
            this.setState({
                ScanByNoErr: `Please enter ${isGateEntry ? 'venue' : 'hall'} ${summaryPage == 'Exit' ? 'exit' : 'entry'} no`
            });
            return;
        }
        this.setState({
            isOpenScanByNoModal: false,
            ScanByNo: '',
            ScanByNoErr: '',
            isOpen: true
        }, () => this.entryGateVerifyQR(ScanByNo.trim()));
    };

    togglePopup = () => {
        this.setState(prev => ({
            showPopup: true
        }));
    };

    record(list) {
        return (
            <table class="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0">
                <thead class="table-light">
                    <tr>
                        <th>Exhibitor Reg. No</th>
                        <th>Material Entry Pass No</th>
                        <th>Material Exit Pass No</th>
                        <th>Company Name</th>
                        <th>Person Name</th>
                        <th>Hall / Stall No</th>
                        <th>Last Entry</th>
                        <th className='text-center'>Entry Count</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        list.length > 0 ? <>{
                            list.map((data, i) => (
                                <tr >
                                    <td>{data.ExhRegistrationNo || '-'}</td>
                                    <td>{data.EntryNo || '-'}</td>
                                    <td>{data.ExitNo || '-'}</td>
                                    <td>{data.CompanyName || '-'}</td>
                                    <td>{data.PersonName || '-'}</td>
                                    <td>{data.LocationDetails || '-'}</td>
                                    <td>{data.LastEntryDate != '' && data.LastEntryDate != null ?
                                        moment.utc(data.LastEntryDate).format('DD/MM/YYYY HH:mm')
                                        : '-'}</td>
                                    <td className='text-center' style={{ width: '20px' }}>
                                        <div className="count-circle" onClick={() => this.setState({ showPopup: true, ExhEntryPassHdrID: data.ExhEntryPassHdrID, ExhExitPassHdrID: data.ExhExitPassHdrID, IsEntryPassLog: data.ExhEntryPassHdrID ? 1 : 0 })}>
                                            {data.EntryCount || 0}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </> :
                            <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                    }
                </tbody>
            </table>)
    }

    updateItem(item) {
        const { EntryGateList } = this.state
        this.setState({ currentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = EntryGateList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(EntryGateList.length / recordsPerPage)
    }

    clearSearch() {
        this.setState({
            CompanyName: '',
            entryDate: new Date(),
            currentPage: 1,
            IsByPass: false,
            Remark: '',
            AdditionalRemark: ''
        }, () => this.entryGateQRList())
    }

    resetFuntion() {
        this.setState({
            Remark: "",
            isChangeFeilds: false,
            InstrunctionErr: '',
            Remark: '',
            isRecording: false,
            Instrunction: "",
            micStatus: "Microphone inactive",
            isRecording2: false,
            micStatus2: "Microphone inactive",
        });
        this.stopRecording()
        this.stopRecording2()
    }

    render() {
        const { isLoading, CompanyName, entryDate, isQrCode, Remark, RemarkErr, IsByPass, IsByPassErr, showPopup, EntryGateMsg, Instrunction, InstrunctionErr, EntryGateList, currentPage, CountPopList, ExhEntryPassHdrID, IsVerify, isChangeFeilds, isGateEntry, isRecording, micStatus, summaryPage, isRecording2, micStatus2, ReasonList, ReasonID, ReasonErr, isOpenConfirmationModal,ExhExitPassHdrID,IsEntryPassLog, isOpenScanByNoModal, ScanByNo, ScanByNoErr } = this.state
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = EntryGateList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(EntryGateList.length / recordsPerPage)
        return (
            <>
                {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />

                <div className="main-content app-content">
                    {/* <AdminDashboardTopmenu /> */}
                    <div className="admin-top-space" >
                        <div className="navg mt-0">
                            <ul className="nav nav-pills tab-scroll-fixed">
                                <li onClick={() => this.setState({ summaryPage: 'Entry', IsEntryExit: 1 }, () => {
                                    this.clearSearch()
                                    sessionStorage.setItem("summaryPage", "Entry")
                                })} className="nav-item ">
                                    {" "}
                                    <a className={summaryPage == 'Entry' ? "nav-link active px-4 py-2" : "nav-link  px-4 py-2"}>
                                        {isGateEntry ? 'Venue' : 'Hall'} Entry{" "}
                                    </a>{" "}
                                </li>
                                <li onClick={() => this.setState({ summaryPage: 'Exit', IsEntryExit: 0 }, () => {
                                    this.clearSearch()
                                    sessionStorage.setItem("summaryPage", "Exit")
                                })} className="nav-item ">
                                    {" "}
                                    <a className={summaryPage == 'Exit' ? "nav-link active px-4 py-2" : "nav-link  px-4 py-2"}>
                                        {isGateEntry ? 'Venue' : 'Hall'} Exit{" "}
                                    </a>{" "}
                                </li>
                            </ul>
                        </div>

                        <div
                            className="com-height"
                        >
                            <div className="page">
                                <div className="page-main">
                                    <div className="main-content app-content">
                                        <div className="side-app p-2">
                                            <div className="main-container px-0 px-md-0">
                                                <div className="row m-0 mt-3">
                                                    <div className="col-xl-3 mb-3">
                                                        <label className="border-0">Company Name</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            defaultValue=""
                                                            maxLength={200}
                                                            value={CompanyName}
                                                            onChange={(e) =>
                                                                this.setState({ CompanyName: e.target.value })
                                                            }
                                                        />
                                                    </div>
                                                    <div className="col-xl-3 mb-3">
                                                        <lable>Entry Date</lable>
                                                        <div className="d-flex gap-2">
                                                            <DatePicker selected={entryDate}
                                                                dateFormat={"dd/MM/yyyy"}
                                                                className="form-control"
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                onChange={(date) => this.setState({ entryDate: date ? date : new Date() })}
                                                                dropdownMode="select"
                                                                placeholderText="Receipt Date"
                                                                dayClassName={() => "example-datepicker-day-class"}
                                                                popperClassName="example-datepicker-class" />
                                                            <button
                                                                type="button"
                                                                className="btn btn-aqua"
                                                                onClick={(e) => this.entryGateQRList()}
                                                                style={{ whiteSpace: "nowrap" }}
                                                            >
                                                                Search
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn btn-aqua"
                                                                onClick={(e) => this.clearSearch()}
                                                                style={{ whiteSpace: "nowrap" }}
                                                            >
                                                                Clear
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-3 mb-3 gap-1 p-2 d-flex align-items-center flex-wrap gap-2">
                                                        <div
                                                            className={`p-1 border-0 fw-semibold status-btn`}
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => this.setState({ isOpen: true })}
                                                        >
                                                            <i className="fa fa-qrcode me-1 fs-6" style={{ border: "none" }} />
                                                            <span>Scan for {isGateEntry ? 'venue' : 'hall'} {summaryPage == 'Exit' ? 'exit' : 'entry'}</span>
                                                        </div>
                                                        <div
                                                            className={`p-1 border-0 fw-semibold status-btn`}
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => this.setState({ isOpenScanByNoModal: true, ScanByNo: '', ScanByNoErr: '' })}
                                                        >
                                                            <i className="fa fa-keyboard-o me-1 fs-6" style={{ border: "none" }} />
                                                            <span>Scan by {summaryPage == 'Exit' ? 'Exit' : 'Entry'} No.</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* <div className="row mt-2">
                                            <div className="col-xl-4 mb-3">
                                                <div className="entry-card" ref={this.cardRef}>
                                                    <div className="count-circle" onClick={this.togglePopup}>
                                                        10
                                                    </div>
                                                    <div className="entry-row">
                                                        <span className="entry-label">Exhibitor Reg. No.:</span>
                                                        <span className="entry-value">EX-10234</span>
                                                    </div>

                                                    <div className="entry-row">
                                                        <span className="entry-label">Company Name:</span>
                                                        <span className="entry-value">ABC Pvt Ltd</span>
                                                    </div>

                                                    <div className="entry-row">
                                                        <span className="entry-label">Person Name:</span>
                                                        <span className="entry-value">John Doe</span>
                                                    </div>

                                                    <div className="entry-row">
                                                        <span className="entry-label">Hall / Stall No:</span>
                                                        <span className="entry-value">001 / 101</span>
                                                    </div>

                                                    <div className="entry-row">
                                                        <span className="entry-label">Last Entry:</span>
                                                        <span className="entry-value">15 Jan 2026, 10:45 AM</span>
                                                    </div>
                                                    <div className={`history-popup ${showPopup ? "active" : ""}`}>
                                                        <div className="popup-title">Entry History</div>

                                                        <div className="history-item">
                                                            <strong>Entry #1</strong>
                                                            <span>12 Jan 2026 — 09:15 AM</span>
                                                        </div>

                                                        <div className="history-item">
                                                            <strong>Entry #2</strong>
                                                            <span>13 Jan 2026 — 11:30 AM</span>
                                                        </div>

                                                        <div className="history-item">
                                                            <strong>Entry #3</strong>
                                                            <span>14 Jan 2026 — 04:20 PM</span>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div> */}

                                                < div className="row m-0 mx-2" >

                                                    <div class="table-responsive px-1 sticky-table-wrapper service-list-grid">
                                                        {this.record(currentRecords)}
                                                    </div>
                                                    <div className="mt-2 float">
                                                        {
                                                            EntryGateList.length > 0 ?
                                                                <Pagination
                                                                    nPages={nPages}
                                                                    currentPage={currentPage}
                                                                    setCurrentPage={this.updateItem}
                                                                /> : <></>
                                                        }
                                                        <div className="tab-rec " style={{ float: "right" }}>
                                                            <p>{`${currentPage} of ${nPages} pages`}</p>
                                                        </div>
                                                    </div>
                                                </div >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div >

                    </div>
                </div>



                <Modal
                    isOpen={this.state.showPopup}
                    onRequestClose={(e) =>
                        this.setState({ showPopup: false })
                    }
                >
                    <div className="modal-dialog modal-lg mt-0">
                        <div className="modal-content">
                            <div class="modal-header text-white p-2 rounded-top-4">
                                <h6 class="modal-title">
                                    Entry Gate Details
                                </h6>

                                <div className="ms-auto d-flex align-items-center gap-3">
                                    <button
                                        type="button"
                                        className="btn-close ms-2"
                                        data-bs-dismiss="modal"
                                        onClick={() => this.setState({ showPopup: false })}
                                        style={{ fontSize: "16px !important" }}
                                    />
                                </div>
                            </div>
                            <div className="modal-body p-0 m-2 entry-gate-details-pop">
                                {CountPopList.length > 0 ?
                                    CountPopList.filter(data => IsEntryPassLog ? data.ExhExitPassHdrID == ExhExitPassHdrID:data.ExhEntryPassHdrID == ExhEntryPassHdrID).map((item, i) => (
                                        <div className="history-item">
                                            <strong>{i + 1}) {item.EntryDate} - {item.EntryTime}</strong>
                                            <p className='m-0'>Instrunction/Remark: {item.Remark || '-'}</p>
                                            {item.IsByPass &&
                                                <p>By Pass Remark: {item.AdditionalRemark || '-'}</p>
                                            }
                                        </div>
                                    ))
                                    : <></>
                                }
                            </div>
                            <div className="modal-footer p-1">
                                <button
                                    type="button"
                                    className="btn btn-gray"
                                    data-bs-dismiss="modal"
                                    onClick={(e) =>
                                        this.setState({ showPopup: false })
                                    }
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal >

                <Modal
                    isOpen={isOpenScanByNoModal}
                    onRequestClose={(e) =>
                        this.setState({ isOpenScanByNoModal: false, ScanByNo: '', ScanByNoErr: '' })
                    }
                >
                    <div className="modal-dialog mt-0">
                        <div className="modal-content">
                            <div class="modal-header text-white p-2 rounded-top-4">
                                <h6 class="modal-title">
                                    Scan by {summaryPage == 'Exit' ? 'Exit' : 'Entry'} No.
                                </h6>
                                <div className="ms-auto d-flex align-items-center gap-3">
                                    <button
                                        type="button"
                                        className="btn-close ms-2"
                                        data-bs-dismiss="modal"
                                        onClick={() => this.setState({ isOpenScanByNoModal: false, ScanByNo: '', ScanByNoErr: '' })}
                                        style={{ fontSize: "16px !important" }}
                                    />
                                </div>
                            </div>
                            <div className="modal-body">
                                <label className="form-label">
                                    {isGateEntry ? 'Venue' : 'Hall'} {summaryPage == 'Exit' ? 'Exit' : 'Entry'} No.<span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={ScanByNo}
                                    autoFocus
                                    onChange={(e) =>
                                        this.setState({ ScanByNo: e.target.value, ScanByNoErr: '' })
                                    }
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            this.submitScanByNo();
                                        }
                                    }}
                                />
                                {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                        {ScanByNoErr}
                                    </span>
                                }
                            </div>
                            <div className="modal-footer p-1">
                                <button
                                    type="button"
                                    className="btn btn-aqua"
                                    onClick={() => this.submitScanByNo()}
                                >
                                    Save
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-gray"
                                    style={{ marginLeft: '5px' }}
                                    onClick={() => this.setState({ isOpenScanByNoModal: false, ScanByNo: '', ScanByNoErr: '' })}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal
                    isOpen={this.state.isOpen}
                    onRequestClose={(e) =>
                        this.setState({ isOpen: false, isQrCode: true })
                    }
                >
                    <div className="modal-dialog modal-lg mt-0">
                        <div className="modal-content">
                            <div class="modal-header text-white p-2 rounded-top-4">
                                <h6 class="modal-title">
                                    {isQrCode ? 'Scan QR Code' : isGateEntry ?
                                        'Entry Gate Details' : summaryPage == 'Exit' ? 'Hall Exit Details' : 'Hall Entry Details'}
                                </h6>
                                {isQrCode && (
                                    <div className="ms-auto d-flex align-items-center gap-3">
                                        <button
                                            type="button"
                                            className="btn-close ms-2"
                                            data-bs-dismiss="modal"
                                            onClick={() => this.setState({ isOpen: false, isQrCode: true }, () => this.resetFuntion())}
                                            style={{ fontSize: "16px !important" }}
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="modal-body" style={{ background: "#f9fafb" }}>
                                <div
                                    className="col-12 pb-1"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        overflow: "hidden",
                                    }}
                                >
                                    {isQrCode ? (
                                        <QrReader
                                            constraints={{ facingMode: "environment" }}
                                            onResult={(result, error) => {
                                                if (result) {
                                                    this.entryGateVerifyQR(result?.text);
                                                }
                                                if (error) {
                                                    console.error(error);
                                                }
                                            }}
                                            containerStyle={{
                                                width: "50%",
                                                height: "100%",
                                                margin: "auto",
                                            }} // 👈 use this
                                            videoStyle={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                            }}
                                        />
                                    ) : (
                                        <div>
                                            {IsVerify ?
                                                <p className="mb-0 text-aqua"><i className="bi bi-check-circle-fill"></i> {EntryGateMsg}</p> :
                                                <p className="mb-0 text-danger"><i className="bi bi-x-circle-fill"></i> {EntryGateMsg}</p>
                                            }
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <label className="form-label">
                                                        Instrunction/Remark
                                                    </label>
                                                    <textarea
                                                        type="text"
                                                        className="form-control w-100 h-auto"
                                                        value={Instrunction}
                                                        onChange={(e) =>
                                                            this.setState({
                                                                Instrunction: e.target.value,
                                                                InstrunctionErr: "",
                                                                isChangeFeilds: true,
                                                            })
                                                        }
                                                    />
                                                </div>
                                                <div className="speech-container">
                                                    <button
                                                        ref={this.recordButtonRef}
                                                        onClick={this.toggleRecording}
                                                        className={`btn ${isRecording ? "btn-danger" : "btn-primary"}`}
                                                        style={{
                                                            marginTop: "10px",
                                                            position: "relative",
                                                            boxShadow: isRecording ? "0 0 10px red" : "none"
                                                        }}
                                                    >
                                                        {isRecording ? "Stop Recording" : "Start Recording"}

                                                        {isRecording && (
                                                            <span
                                                                style={{
                                                                    position: "absolute",
                                                                    top: "-6px",
                                                                    right: "-6px",
                                                                    width: "14px",
                                                                    height: "14px",
                                                                    background: "red",
                                                                    borderRadius: "50%",
                                                                    animation: "pulse 1.5s infinite"
                                                                }}
                                                            />
                                                        )}
                                                    </button>

                                                    <p style={{ marginTop: "8px", color: isRecording ? "#dc3545" : "#666" }}>
                                                        {micStatus}
                                                    </p>
                                                </div>
                                                {!IsVerify &&
                                                    <>
                                                        <div className="col-md-6">
                                                            <div className="d-flex justify-content-between align-items-center mb-2 mt-3">
                                                                <div className="section-title mb-0 fw-semibold">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={IsByPass}
                                                                        value={IsByPass}
                                                                        onChange={(e) =>
                                                                            this.setState({
                                                                                IsByPass: e.target.checked,
                                                                                isChangeFeilds: true,
                                                                                IsByPassErr: "",
                                                                            })
                                                                        }
                                                                    />{" "}
                                                                    By Pass
                                                                </div>
                                                            </div>
                                                            {
                                                                <span className="text-danger text-start text-left d-block mt-1">
                                                                    {IsByPassErr}
                                                                </span>
                                                            }
                                                        </div>
                                                        {IsByPass &&
                                                            <>
                                                                <div class="row">
                                                                    <div class="col-md-6">
                                                                        <label class="ms-1">Reason<span className="text-danger">*</span></label>
                                                                        <select
                                                                            className="form-control"
                                                                            id="roledb"
                                                                            value={ReasonID}
                                                                            onChange={(e) =>
                                                                                this.setState({ ReasonID: e.target.value, ReasonErr: '' })
                                                                            }
                                                                        >
                                                                            <option value={""}>Select</option>
                                                                            {ReasonList.length > 0 &&
                                                                                ReasonList.map((data) => (
                                                                                    <option key={data.ReasonID} value={data.ReasonID}>
                                                                                        {data.Reason}
                                                                                    </option>
                                                                                ))}
                                                                        </select>
                                                                        {
                                                                            <span className="text-danger text-start text-left d-block mt-1">
                                                                                {ReasonErr}
                                                                            </span>
                                                                        }
                                                                    </div>
                                                                    {ReasonID == 2 &&
                                                                        <div className="col-md-12">
                                                                            <label className="form-label">
                                                                                Remark
                                                                                <span className="text-danger">*</span>
                                                                            </label>
                                                                            <textarea
                                                                                type="text"
                                                                                className="form-control w-100 h-auto"
                                                                                value={Remark}
                                                                                onChange={(e) =>
                                                                                    this.setState({
                                                                                        Remark: e.target.value,
                                                                                        isChangeFeilds: true,
                                                                                        RemarkErr: "",
                                                                                    })
                                                                                }
                                                                            />
                                                                            {
                                                                                <span className="text-danger text-start text-left d-block mt-1">
                                                                                    {RemarkErr}
                                                                                </span>
                                                                            }
                                                                            <div className="speech-container">
                                                                                <button
                                                                                    ref={this.recordButtonRef}
                                                                                    onClick={this.toggleRecording2}
                                                                                    className={`btn ${isRecording2 ? "btn-danger" : "btn-primary"}`}
                                                                                    style={{
                                                                                        marginTop: "10px",
                                                                                        position: "relative",
                                                                                        boxShadow: isRecording2 ? "0 0 10px red" : "none"
                                                                                    }}
                                                                                >
                                                                                    {isRecording2 ? "Stop Recording" : "Start Recording"}

                                                                                    {isRecording2 && (
                                                                                        <span
                                                                                            style={{
                                                                                                position: "absolute",
                                                                                                top: "-6px",
                                                                                                right: "-6px",
                                                                                                width: "14px",
                                                                                                height: "14px",
                                                                                                background: "red",
                                                                                                borderRadius: "50%",
                                                                                                animation: "pulse 1.5s infinite"
                                                                                            }}
                                                                                        />
                                                                                    )}
                                                                                </button>

                                                                                <p style={{ marginTop: "8px", color: isRecording2 ? "#dc3545" : "#666" }}>
                                                                                    {micStatus2}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </>
                                                        }
                                                    </>
                                                }

                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="modal-footer p-1">
                                {/* {!isQrCode && (
                                    <button
                                        type="button"
                                        className="btn btn-aqua"
                                        data-bs-dismiss="modal"
                                        onClick={(e) => isChangeFeilds ? this.submitEntryGateQR(e) : this.setState({ isChangeFeilds: false, isOpen: false, isQrCode: true, InstrunctionErr: '', Remark: '' }, () => this.resetFuntion())}
                                    >
                                        {isChangeFeilds ? 'Submit' : 'Close'}
                                    </button>
                                )} */}
                                {!isQrCode && (
                                    <button
                                        type="button"
                                        className="btn btn-aqua"
                                        data-bs-dismiss="modal"
                                        // onClick={(e) => this.submitEntryGateQR(e)}
                                        onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to Submit?`, buttonName: "Submit", action: 0 }, popArg: [] })}
                                    >
                                        Submit
                                    </button>
                                )}
                                {/* {isQrCode && ( */}
                                <button type="button" class="btn btn-aqua" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                    onClick={() => this.setState({ isChangeFeilds: false, isOpen: false, isQrCode: true, InstrunctionErr: '', Remark: '', IsByPass: false }, () => this.resetFuntion())}
                                >Close</button>
                                {/* )} */}
                            </div>
                        </div>
                    </div>
                </Modal >
            </>
        );
    }
}

export default withRouter(connect(null, {
    entryGateVerifyQR_action, entryGateQRList_action, entryGateUpdateAccessPassLog_action, fill_action
})(EntryGate));